import React from 'react';

const dropdownContext = React.createContext();

export default dropdownContext;